import { Dialog, DialogContent } from '@/components/ui/dialog';
import { AddIngredientForm } from '@/features/ingredients/components/add-organisation-ingredient';

interface AddManagedIngredientModalProps {
  supplierId: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AddManagedIngredientModal = ({
  open,
  onOpenChange,
  supplierId,
}: AddManagedIngredientModalProps) => {
  const handleOpenChange = (open: boolean) => {
    onOpenChange(open);
  };

  const handleBack = () => {
    handleOpenChange(false);
  };

  const handleFormReset = () => {
    // Custom reset logic can be added here if needed
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="p-0 overflow-hidden gap-0 top-[25%] translate-y-[0]">
        <AddIngredientForm
          selectedSupplierId={supplierId}
          tenantId={null}
          onBack={handleBack}
          onFormReset={handleFormReset}
          title="Add New Managed Ingredient"
        />
      </DialogContent>
    </Dialog>
  );
};
